import React from 'react'
import { CHAMPIONSHIP_SERIES, PLL_IMAGES } from '../../../../Config/config'
import { colors } from '../../../../Components/consts'
import { AnnouncementCallout } from '../../../../Components/Callout/AnnouncementCallout'

export const WLLCallout: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <AnnouncementCallout
      leftBorderColor={colors.yellow}
      title={`WLL Championship Series Schedule`}
      buttonText={`View Schedule`}
      buttonLink={`${CHAMPIONSHIP_SERIES}/schedule`}
      description={``}
      image={PLL_IMAGES.wllShield}
    />
  )
}
